export default "__VITE_ASSET__BycUEDOd__"